import type { CouponIdentifiers } from '../../../../schema/coupon/entry.js';
import { getInstanceClient } from '../../../di/entry.browser.js';
import type { ActionStatus } from '../../../lib/entry.js';

type DeleteCouponArgs = CouponIdentifiers;

/**
 * Deletes a given coupon.
 *
 * @param root0 Function args
 * @param root0.couponId Unique coupon ID
 * @param root0.couponIndex Unique coupon index
 * @returns SUCCESS if successful, otherwise ERROR
 */
export async function deleteCoupon({ couponId, couponIndex }: DeleteCouponArgs): Promise<ActionStatus> {
  const deleteCouponController = getInstanceClient('IDeleteCouponController');
  try {
    const isDeleted = await deleteCouponController({ couponId, couponIndex });

    return isDeleted ? 'SUCCESS' : 'ERROR';
  } catch {
    return 'ERROR';
  }
}
